<template>
  <div class="suspended-shell">
    <div class="suspended-card">
      <div class="eyebrow">Access Restricted</div>
      <h1>Company access is currently {{ label.toLowerCase() }}.</h1>
      <p>
        Your company workspace is not available right now. This usually happens when billing is overdue or when access has been turned off by SuperAdmin.
      </p>

      <div class="status-chip">{{ label }}</div>

      <div class="actions">
        <router-link class="btn btn-dark" to="/billing">Open Billing</router-link>
        <router-link class="btn btn-outline-secondary" to="/dashboard/admin-dashboard">Go to Dashboard</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useAccessStore } from "@/stores/accessStore";

const access = useAccessStore();
const label = computed(() => access.companyStatus || "Suspended");
</script>

<style scoped>
.suspended-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top left, rgba(220,38,38,.08), transparent 26%),
    radial-gradient(circle at bottom right, rgba(15,23,42,.10), transparent 32%),
    #f8fafc;
}
.suspended-card {
  width: 100%;
  max-width: 760px;
  background: #fff;
  padding: 40px;
  border-radius: 28px;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.14);
}
.eyebrow {
  font-size: 12px;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 700;
  margin-bottom: 12px;
}
h1 {
  margin: 0 0 14px;
  font-size: 38px;
  line-height: 1.05;
}
p {
  margin: 0;
  line-height: 1.8;
  color: #475569;
}
.status-chip {
  display: inline-flex;
  margin-top: 24px;
  padding: 10px 14px;
  border-radius: 999px;
  font-weight: 700;
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
}
.actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 28px;
}
</style>
